import React from 'react';
import { UserPlus, CheckCircle2, ChevronRight } from 'lucide-react';

const RecruitmentSection = () => {
  const benefits = [
    'Competitive compensation packages',
    'Flexible scheduling options',
    'Professional development opportunities',
    'Work across Florida locations',
    'Join an elite security team',
  ];

  return (
    <section id="careers" className="relative py-24 lg:py-32 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#050505] via-black to-[#050505]" />
      
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left - Content */}
          <div>
            <span className="text-[#00D4FF] text-sm font-semibold tracking-wider uppercase mb-4 block">
              Join Our Team
            </span>
            <h2 className="text-3xl lg:text-5xl font-bold text-white mb-6">
              Are You a Licensed
              <br />
              <span className="text-[#00D4FF]">Armed Guard?</span>
            </h2>
            <p className="text-gray-400 text-lg leading-relaxed mb-8">
              We're always looking for dedicated, professional licensed armed security
              officers to join our growing team across Florida. Take your career to
              the next level with Armed Guard Officer.com.
            </p>

            {/* Benefits List */}
            <ul className="space-y-4 mb-10">
              {benefits.map((benefit, index) => (
                <li key={index} className="flex items-center gap-3">
                  <CheckCircle2 className="w-5 h-5 text-[#00D4FF] flex-shrink-0" />
                  <span className="text-gray-300">{benefit}</span>
                </li>
              ))}
            </ul>

            {/* CTA */}
            <a
              href="#contact"
              className="group inline-flex items-center gap-3 bg-[#00D4FF] text-black px-8 py-4 font-semibold text-lg hover:shadow-[0_0_40px_rgba(0,212,255,0.5)] transition-all duration-300"
            >
              <UserPlus className="w-5 h-5" />
              Apply to Join Our Team
              <ChevronRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </a>
          </div>

          {/* Right - Visual */}
          <div className="relative">
            <div className="relative">
              {/* Main card */}
              <div className="bg-gradient-to-br from-white/10 to-white/5 border border-white/10 p-10 backdrop-blur-sm">
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#00D4FF] to-transparent" />
                
                <div className="text-center">
                  <div className="w-24 h-24 mx-auto mb-6 bg-[#00D4FF]/10 flex items-center justify-center">
                    <UserPlus className="w-12 h-12 text-[#00D4FF]" strokeWidth={1.5} />
                  </div>
                  
                  <h3 className="text-2xl font-bold text-white mb-4">
                    Requirements
                  </h3>
                  
                  <ul className="text-left space-y-3 text-gray-400">
                    <li className="flex items-start gap-3">
                      <span className="text-[#00D4FF] font-bold">01</span>
                      <span>Valid Florida Class G License</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="text-[#00D4FF] font-bold">02</span>
                      <span>Clean background check</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="text-[#00D4FF] font-bold">03</span>
                      <span>Professional demeanor</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="text-[#00D4FF] font-bold">04</span>
                      <span>Reliable transportation</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="text-[#00D4FF] font-bold">05</span>
                      <span>Commitment to excellence</span>
                    </li>
                  </ul>
                </div>
              </div>

              {/* Floating badge */}
              <div className="absolute -bottom-6 -right-6 bg-black border border-[#00D4FF]/50 p-4 shadow-[0_0_30px_rgba(0,212,255,0.2)]">
                <p className="text-xs text-gray-400">NOW HIRING</p>
                <p className="text-xl font-bold text-[#00D4FF]">Across Florida</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RecruitmentSection;
